import React, { Component } from 'react';
import LoadingScreen from '../includes/LoadingScreen';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { Alert } from 'react-bootstrap';
import APIController from '../controller/APIController';
import UserController from '../controller/UserController';


class EinverstaendniserklaerungCheckbox extends Component {
  constructor(props) {


    if(props.traineeProfile.userConsent == null){
      props.traineeProfile.userConsent = {
        consentEvents: []
      }
    }

    super(props);
    this.state = {
      isFetching: true,
      traineeProfile: props.traineeProfile,
      answerGiven: (props.traineeProfile.userConsent.consentEvents.length > 0)
    }

  }

  async resetAnswer() {
    try {
      if(this.state.answerGiven && this.isAccepted()){
        if (window.confirm("Einverständniserklärung zu Foto- & Videoaufnahmen wirklich widerrufen?")) {
          await this.sendAblehnen();
        }
      }else{
        this.setState(prevState => ({
          ...prevState,
          isFetching: true
        }));

        this.setState(prevState => ({
          ...prevState,
          answerGiven: false,
          isFetching: false,
        }));
      }
    } catch (error) {
      console.log(error);
    }
  }

  async sendAblehnen() {
    try {
      this.setState(prevState => ({
        ...prevState,
        isFetching: true
      }));
      await APIController.upsertImageAndVideoConsent(false);
      await this.reload();

      this.setState(prevState => ({
        ...prevState,
        answerGiven: true,
        agbAkzeptiert: false,
        isFetching: false,
      }));
    } catch (error) {
      console.log(error);
    }
  }

  async sendAkzeptieren() {
    try {
      this.setState(prevState => ({
        ...prevState,
        isFetching: true
      }));


      await APIController.upsertImageAndVideoConsent(true);
      await this.reload();

      this.setState(prevState => ({
        ...prevState,
        answerGiven: true,
        isFetching: false,
      }));
    } catch (error) {
      console.log(error);
    }
  }


  async reload() {
    try {
      this.setState(prevState => ({
        ...prevState,
        isFetching: true
      }));

      const profileResponse = await APIController.getTraineeProfile(UserController.getUser().id);
      if(profileResponse.userConsent == null){
        profileResponse.userConsent = {
          consentEvents: []
        }
      }
      this.setState(prevState => ({
        ...prevState,
        isFetching: false,
        answerGiven: (profileResponse.userConsent.consentEvents.length > 0),
        traineeProfile: profileResponse
      }));


    } catch (error) {
      console.log(error);
    }
  }

  componentDidMount() {
    this.reload();
  }


  isAccepted(){
    const consentEvents = this.state.traineeProfile.userConsent.consentEvents;
      const latestConsentEvent = consentEvents.reduce((latest, current) => {
        return new Date(current.date) > new Date(latest.date) ? current : latest;
      }, consentEvents[0]);
      if (latestConsentEvent) {
        return latestConsentEvent.accepted;
      } else {
        return false; // oder ein Fallback-Text, wenn keine Daten vorhanden sind
      }
  }

  renderConsentAlert(){
    const consentEvents = this.state.traineeProfile.userConsent.consentEvents;
      // Jüngstes Ereignis finden
      const latestConsentEvent = consentEvents.reduce((latest, current) => {
        return new Date(current.date) > new Date(latest.date) ? current : latest;
      }, consentEvents[0]);
      if (latestConsentEvent) {
        const alertVariant = latestConsentEvent.accepted ? 'success' : 'warning';
        const statusText = latestConsentEvent.accepted ? 'bestätigt' : 'abgelehnt';
        return (
          <Alert variant={alertVariant}>
            <a href="/AGB_Einverstaendniserklärung_Foto_Video_080425.pdf">
              <FontAwesomeIcon icon={faFilePdf} /> Einverständniserklärung
            </a>{' '}
            zu Foto- & Videoaufnahmen <i>{statusText} am {latestConsentEvent.date}</i>.{' '}
            <a onClick={() => this.resetAnswer()} href="#">widerrufen</a>
          </Alert>
        );
      } else {
        return <></>; // oder ein Fallback-Text, wenn keine Daten vorhanden sind
      }
  }

  render() {


    if (this.state.isFetching) {
      return (<LoadingScreen></LoadingScreen>)
    }

    if (this.state.answerGiven) {
      return (
        <div className='EinverstaendniserklaerungCheckbox'>
          <div className="row">
            <div className="col-auto">
              {this.renderConsentAlert()}
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div className='EinverstaendniserklaerungCheckbox'>
          <div className="row">
            <div className="col-auto">
              <div className="p-3" style={{background:'#f4f4f4'}}>
                Hiermit bestätige ich, dass ich die <a target="_blank" 
                title='Einverständniserklärung zu Foto- & Videoaufnahmen PDF öffnen' alt='Einverständniserklärung zu Foto- & Videoaufnahmen PDF öffnen'
                href='/AGB_Einverstaendniserklärung_Foto_Video_080425.pdf'><FontAwesomeIcon icon={faFilePdf}></FontAwesomeIcon> Einverständniserklärung</a> zu Foto- & Videoaufnahmen gelesen und akzeptiert habe.
              </div>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-auto">
              <button onClick={() => this.sendAkzeptieren()} className="btn btn-primary me-1">Ja, bestätigen</button>
              <button onClick={() => this.sendAblehnen()} className="btn btn-primary">Nein, ablehnen</button>
            </div>
          </div>
        </div>
      )
    }


  }
}
export default EinverstaendniserklaerungCheckbox;